// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-update-log-detail ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 5px;\n}\n.data-update-log-detail ul li {\n    margin: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
